import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Dropdown as AntDropdown } from "antd";
import classNames from "classnames";
import "./Dropdown.scss";
import { listenForPopupCloseClick, styleClasses } from "../../helpers";
import { Button } from "../Buttons/Button";
import { Menu } from "../Menu";
const CSS_PREFIX = `lav-components-dropdown`;
export const Dropdown = (_a) => {
    var { arrow = true, children, className = "", disabled, icon, iconColor, menuProps, prefix, separator, size = "medium", variant = "default" } = _a, antDropdownProps = __rest(_a, ["arrow", "children", "className", "disabled", "icon", "iconColor", "menuProps", "prefix", "separator", "size", "variant"]);
    const [menuOpen, setMenuOpen] = useState(false);
    return (_jsxs("div", { className: classNames(styleClasses(CSS_PREFIX + "-container", {
            disabled,
            menuOpen,
            separator,
            size,
            variant,
        }), { [className]: !!className }), children: [_jsx(AntDropdown, Object.assign({ className: classNames(styleClasses(CSS_PREFIX, {
                    disabled,
                    menuOpen,
                    size,
                    variant,
                    arrow,
                }), { [className]: !!className }), trigger: [], disabled: disabled }, antDropdownProps, { children: icon ? (_jsx(Button, { variant: variant, suffix: arrow ? "IconChevronDown" : undefined, state: disabled ? "disabled" : undefined, className: classNames(styleClasses(CSS_PREFIX, {
                        disabled,
                        separator,
                        size,
                        variant,
                        icon,
                    }), { [className]: !!className }), size: size, prefix: prefix, onClick: () => {
                        if (!menuOpen) {
                            listenForPopupCloseClick("#lav-dropdown-popup-menu", CSS_PREFIX + "-container", () => setMenuOpen(false));
                        }
                        setMenuOpen((open) => !open);
                    }, icon: icon, iconColor: iconColor })) : (_jsx(Button, { variant: "plain", suffix: arrow ? "IconChevronDown" : undefined, radius: "md", state: disabled ? "disabled" : undefined, className: classNames(styleClasses(CSS_PREFIX, {
                        disabled,
                        separator,
                        size,
                        variant,
                    }), { [className]: !!className }), size: size, prefix: prefix, onClick: () => {
                        if (!menuOpen) {
                            listenForPopupCloseClick("#lav-dropdown-popup-menu", CSS_PREFIX + "-container", () => setMenuOpen(false));
                        }
                        setMenuOpen((open) => !open);
                    }, children: children })) })), menuOpen && (_jsx("div", { style: { position: "absolute", marginTop: 8 }, id: "lav-dropdown-popup-menu", children: _jsx(Menu, Object.assign({}, menuProps, { onSelect: (props) => {
                        var _a;
                        !menuProps.multiple && setMenuOpen(false);
                        (_a = menuProps.onSelect) === null || _a === void 0 ? void 0 : _a.call(menuProps, props);
                    } })) }))] }));
};
